import { render, staticRenderFns } from "./Card.vue?vue&type=template&id=045a0392&scoped=true"
import script from "./Card.vue?vue&type=script&lang=ts"
export * from "./Card.vue?vue&type=script&lang=ts"
import style0 from "./Card.vue?vue&type=style&index=0&id=045a0392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045a0392",
  null
  
)

export default component.exports